import { Component, Input, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { MatSelectModule } from '@angular/material/select';
import { MatIconModule } from '@angular/material/icon';
import { MappingExportEnvelope, MappingVersion } from '../../../models/bulk-payment.model';
import { BulkPaymentMappingService } from '../../../services/bulk-payment-mapping.service';

@Component({
  selector: 'app-export-mapping-modal',
  standalone: true,
  imports: [CommonModule, FormsModule, MatSelectModule, MatIconModule],
  templateUrl: './export-mapping-modal.component.html',
})
export class ExportMappingModalComponent implements OnInit {
  @Input() data: any;

  versions: MappingVersion[] = [];
  selectedVersion: MappingVersion | null = null;

  ngOnInit(): void {
    this.versions = this.data?.data?.versions ?? [];
    if (this.versions.length > 0) {
      this.selectedVersion = this.versions[0]; // newest first
    }
  }

  get previewJson(): string {
    if (!this.selectedVersion) return '';
    return JSON.stringify(this.selectedVersion.mapping, null, 2);
  }

  getVersionLabel(v: MappingVersion): string {
    const date = new Date(v.createdAt).toLocaleString();
    return `Version ${v.version}  —  saved ${date}`;
  }

  compareVersions(a: MappingVersion, b: MappingVersion): boolean {
    return a?.version === b?.version;
  }

  getSelectedEnvelope(): MappingExportEnvelope | null {
    if (!this.selectedVersion) return null;
    // delegate to service so the envelope type/name constants are canonical
    const svc: BulkPaymentMappingService = this.data?.data?.mappingService;
    return svc ? svc.buildEnvelope(this.selectedVersion) : null;
  }
}
